import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=0a09c050&scoped=true&"
import script from "./ExportButton.vue?vue&type=script&lang=js&"
export * from "./ExportButton.vue?vue&type=script&lang=js&"
import style0 from "./ExportButton.vue?vue&type=style&index=0&id=0a09c050&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a09c050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
